import { createSelector } from "reselect";
import { createMakeSelectCurrentPage } from "lib/providers/pagination-provider/selectors";
import { makeSelectEntityStatuses } from "entities/entity_status/selectors";
import { makeSelectTranslation } from "../translation/selectors";
import { makeSelectStringSource } from "../stringResources/selectors";

const selectEntity = state => state.entities.alg_meta_skill;
const selectEntityData = state =>
  state.entities.alg_meta_skill ? state.entities.alg_meta_skill.data : {};

export const makeSelectMetaSKill = paginationKey =>
  createSelector(
    [
      selectEntityData,
      createMakeSelectCurrentPage(paginationKey)(),
      makeSelectEntityStatuses(),
      makeSelectStringSource(),
      makeSelectTranslation()
    ],
    (substate, page, statuses, resources, translations) => {
      if (!paginationKey) {
        return substate;
      }

      if (page.length > 0)
        return page
          .map(id => {
            if (!substate[id]) {
              return null;
            }

            const metaSkill = { ...substate[id] };
            metaSkill.entity_status = statuses[metaSkill.entity_status.id];
            for (let string of resources) {
              if (string.id === metaSkill.name)
                metaSkill.string_resources = string;
            }
            const newTranslations = [];
            for (let translation of metaSkill.string_resources.translations) {
              newTranslations.push(translations[translation.id]);
            }
            metaSkill.string_resources.translations = newTranslations;

            return metaSkill;
          })
          .filter(row => row);
    }
  );

export const makeSelectMetaSKillLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.isLoading;
  });

export const makeSelectMetaSKillError = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.error;
  });
